import Vue from 'vue'

import { mapMutations, mapActions } from 'vuex'

export default Vue.extend({
  template: `
        <b-form-select @change="onSelectionChange" v-model="selected" :options="options" style="width: 80%" size="sm" class="trainingSelector"></b-form-select>
  `,
  data() {
    return {
      selected: [],
      options: [
        {
          text: '1',
          value: '1'
        },
        {
          text: '2',
          value: '2'
        },
        {
          text: '3',
          value: '3'
        },
        {
          text: '4',
          value: '4'
        },
        {
          text: '5',
          value: '5'
        },
        {
          text: '6',
          value: '6'
        },
        {
          text: '7',
          value: '7'
        },
        {
          text: '8',
          value: '8'
        },
        {
          text: '9',
          value: '9'
        }
      ]
    }
  },
  created() {
    const { group } = this.params.data
    if (group) {
      this.selected = group
    }
  },
  methods: {
    ...mapMutations({
      updateTeams: 'educationStudentsManagement/updateTeams',
      updateStudent: 'educationStudentsManagement/updateStudent'
    }),
    ...mapActions({
      sendMessage: 'socket/sendMessage'
    }),
    onSelectionChange(val) {
      if (this.params.data.role) {
        this.updateTeams({
          team: val,
          role: {
            id: this.params.data.id,
            role: this.params.data.role
          },
          oldTeam: this.params.data.group
        })
      }
      this.sendMessage({
        action: 'trainingRegistrationUpdate',
        data: {
          userId: this.params.data.id,
          role: this.params.data.role,
          group: val
        }
      })
      this.updateStudent({
        id: this.params.data.id,
        role: this.params.data.role,
        group: val
      })
    }
  }
})
